<script setup>
import { useAuthStore } from '@/Stores/auth.js'
const auth = useAuthStore()

const contactEmail = process.env.MIX_CONTACT_EMAIL

// change the email to a mailto link
const contactEmailLink = `mailto:${contactEmail}`

</script>

<template>
	<SectionCard title="App Documentation">
		<Heading size="2">Documentation</Heading>
		<p>Welcome to the Advance Cairns Member Portal documentation. The Member Portal allows you to keep your member data up to date, make payments on memberships and review events hosted by Advance Cairns. If you have a question that is not covered by the documentation, please contact us at: <a :href="contactEmailLink">{{contactEmail}}</a>.</p>

		<br />
		<Heading size="3">Contents</Heading>

		<ul>
			<li><Link :href="route('dashboard.docs.add-payment-method')">Adding a Payment Method</Link></li>
			<li><Link :href="route('dashboard.docs.managing-invoices')">Managing Invoices</Link></li>
			<li v-if="auth.isAdmin"><Link :href="route('dashboard.docs.handling-applications')">Handling Membership Applications</Link></li>
		</ul>

	</SectionCard>
</template>